import { render, staticRenderFns } from "./InputAddImage.vue?vue&type=template&id=1a574546&scoped=true&"
import script from "./InputAddImage.vue?vue&type=script&lang=js&"
export * from "./InputAddImage.vue?vue&type=script&lang=js&"
import style0 from "./InputAddImage.vue?vue&type=style&index=0&id=1a574546&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a574546",
  null
  
)

export default component.exports